export default __webpack_public_path__ + "media/media/step1_createProject-f6d1c001.mp4";